export class Error {
    errorMessage: string = "Unknown error";
    constructor() {
    }

    activate(routeParams) {
        if (routeParams.errorMessage) {
            this.errorMessage = routeParams.errorMessage;
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/components/error/error.ts